module.exports = __webpack_public_path__ + "img/dryva-wf-6.f19a5602.png";